import React from 'react';

import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import st from './DefaultFaceFormFields.module.sass';
import type { DefaultFaceFormFieldsProps } from '../types';

function DefaultFaceFormFieldsComponent({
  listOptions,
  noSelect,
}: DefaultFaceFormFieldsProps): React.JSX.Element {
  const { t } = useTranslation();
  const { register, control, formState: { errors } } = useFormContext();

  return (
    <div className={st.InfoForm}>
      <div className={st.TextAreaContainer}>
        <Control.Textarea
          className={st.TextArea}
          data-testid="faceCreateFormTextarea"
          id="user_data"
          label={t('monokit:create face modal.forms.information')}
          rows={2}
          {...register('user_data', {
            maxLength: validate.maxLength(128),
          })}
          errors={errors}
        />
      </div>
      {!noSelect && (
        <div className={st.SelectContainer}>
          <Control.Select
            className={st.Select}
            control={control}
            errors={errors}
            id="lists"
            isMulti
            label={(t('monokit:create face modal.forms.lists'))}
            name="lists"
            options={listOptions}
          />
        </div>
      )}
    </div>
  );
}

export const DefaultFaceFormFields = connect(
  (state) => ({
    listOptions: selectListOptions(state),
  }),
)(DefaultFaceFormFieldsComponent);
